import React from 'react';

import {
  useVersionMigration,
  useVersionPromotion,
} from 'app/developer-v3/hooks';

import CTAVersioning from './CTAVersioning';

type Props = {
  integrationId: ID;
};

function CTAVersionLifecycle(props: Props) {
  const { integrationId } = props;

  const versionMigration = useVersionMigration(integrationId);
  const versionPromotion = useVersionPromotion(integrationId);

  return versionMigration.isMigrated || versionMigration.isPending ? (
    <CTAVersioning.Migration
      error={versionMigration.error}
      hasError={versionMigration.hasError}
      integrationId={integrationId}
      isMigrated={versionMigration.isMigrated}
      isPending={versionMigration.isPending}
      migrationDate={versionMigration.migratedDate}
      migrationId={versionMigration.id}
      versionFrom={versionMigration.versionFrom}
      versionTo={versionMigration.versionTo}
    />
  ) : versionPromotion.isPromoted || versionPromotion.isPending ? (
    <CTAVersioning.Promotion
      error={versionPromotion.error}
      hasError={versionPromotion.hasError}
      integrationId={integrationId}
      isPending={versionPromotion.isPending}
      isPromoted={versionPromotion.isPromoted}
      promotionDate={versionPromotion.promotedDate}
      promotionId={versionPromotion.id}
      version={versionPromotion.version}
    />
  ) : null;
}

export default CTAVersionLifecycle;
